import { CountryCode } from '@nx-customer-apps/shared/enums';
import { Mask } from '@nx-customer-apps/shared/interfaces';

export const getPostalCodeMask = (countryCode: string): Mask => {
    const pattern = countryCode === CountryCode.DE ? '00000' : '0000';
    return { pattern };
};
